import { Link } from "design-system/components/primitives/link/link";

export interface ArticleFooterTagProps {
  label: string;
  link: string;
}

export function ArticleFooterTag({ label, link }: ArticleFooterTagProps) {
  if (label && link) {
    return (
      <Link className="hbs-article-footer-tag" href={link}>
        {label}
      </Link>
    );
  }

  return <span className="hbs-article-footer-nolink-tag">{label}</span>;
}
